import {
  Card,
  Col,
  Avatar,
  Image,
  List,
  Row,
  Typography,
  Button,
  Popconfirm,
  Spin,
} from "antd";
import React, { useEffect, useMemo } from "react";
import { CheckCircleOutlined, CalendarOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import { useParams, useNavigate, Link } from "react-router-dom";
import {
  actionDeleteUser,
  actionGetTicketDetail,
} from "../../store/actions/ticketAction";
const { Title, Text } = Typography;
const ViewTicket = (props) => {
  const Navigate = useNavigate();
  const {
    actionGetTicketDetail,
    ticketsDetailLoader,
    ticketsDetailData,
    actionDeleteUser,
  } = props;
  const { ticketId } = useParams();

  useEffect(() => {
    actionGetTicketDetail(ticketId);
  }, []);

  console.log(ticketsDetailData);
  const data = [
    {
      title: "Service Request No:",
      description: (
        <>{ticketsDetailData && ticketsDetailData.service_request_number}</>
      ),
    },
    {
      title: "Email",
      description: <>{ticketsDetailData && ticketsDetailData.email}</>,
    },
    {
      title: "Describe the Issue:",
      description: <>{ticketsDetailData && ticketsDetailData.description}</>,
    },

    {
      title: "Primary Troubleshooting:",
      description: (
        <>
          <p style={{ textTransform: "lowercase" }}>
            {ticketsDetailData && ticketsDetailData.primary_troubleshooting}
          </p>
        </>
      ),
    },
    {
      title: "Steps Primary Troubleshooting:",
      description: (
        <>
          <p style={{ textTransform: "lowercase" }}>
            {ticketsDetailData &&
              ticketsDetailData.primary_troubleshooting_description}
          </p>
        </>
      ),
    },
    {
      title: "Issue according to Priority:",
      description: (
        <>
          {" "}
          <p style={{ textTransform: "lowercase" }}>
            {ticketsDetailData && ticketsDetailData.rate_issuue}
          </p>
        </>
      ),
    },
    {
      title: "Status:",
      description: (
        <>
          <p style={{ textTransform: "lowercase" }}>
            {ticketsDetailData && ticketsDetailData.status}
          </p>
        </>
      ),
    },
    // {
    //     title: "Screenshot:::",
    //     description: <><p style={{ textTransform: 'lowercase' }}>{ticketsDetailData && ticketsDetailData.roles}</p></>,
    // },
  ];

  const confirm = (id) => {
    actionDeleteUser(id, Navigate);

    console.log("deleted");
  };

  return (
    <>
      <Spin spinning={ticketsDetailLoader}>
        <div className="user-detail">
          <Row gutter={16}>
            <Col span={17}>
              <Card
                className="big-card"
                title={
                  <>
                    <Typography.Title level={4}>
                      <div>
                        View Ticket<span className="text-line"></span>
                      </div>
                    </Typography.Title>
                  </>
                }
                bordered={false}
              >
                <List
                  itemLayout="horizontal"
                  dataSource={data}
                  renderItem={(item, index) => (
                    <List.Item
                      style={{
                        backgroundColor: index % 2 === 0 ? "#fff" : "#F1F5F9",
                      }}
                    >
                      <List.Item.Meta
                        title={item.title}
                        description={item.description}
                      />
                    </List.Item>
                  )}
                />
                <br />
                {/* <Col span={10}> */}
                {/* <Button  htmlType="button" size="large" onClick={() => deleteUser(ticketsDetailData._id)}> */}

                <Popconfirm
                  title="Are you sure you want to delete this Ticket?"
                  onConfirm={() => confirm(ticketsDetailData.ticket_id)}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button htmlType="button" size="large">
                    Delete
                  </Button>
                </Popconfirm>
                {/* </Col> */}
              </Card>
            </Col>
          </Row>
        </div>
      </Spin>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    ticketsDetailLoader: state.ticket.ticketsDetailLoader,
    ticketsDetailData: state.ticket.ticketsDetailData,
  };
};

export default connect(mapStateToProps, {
  actionGetTicketDetail,
})(ViewTicket);
